"use client";

let tabId: string | undefined;
export const getTabId = () => {
  if (tabId === undefined) tabId = crypto.randomUUID();
  return tabId;
};

export function notifyLogout() {
  if (typeof BroadcastChannel === "undefined") return;
  const ch = new BroadcastChannel("casino_auth");
  ch.postMessage({
    type: "logout",
    from: getTabId(),
  });
  ch.close();
}

/*
  TODO: Enable the login
export function notifyLogin() {
  if (typeof BroadcastChannel === "undefined") {
    return
  }
  new BroadcastChannel("casino_auth").postMessage("login");
}
 */
